import { render, staticRenderFns } from "./modalBemVindo.vue?vue&type=template&id=276665e3&"
import script from "./modalBemVindo.vue?vue&type=script&lang=js&"
export * from "./modalBemVindo.vue?vue&type=script&lang=js&"
import style0 from "./modalBemVindo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "modalBemVindo.vue"
export default component.exports